import { useTranslation } from 'react-i18next';
import { EmailIcon, EmailShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import { toast } from 'react-toastify';

import { Icon, Modal } from 'components';
import { useSafeState } from 'hooks';
import { copyToClipboard } from 'services';

const SocialShare = () => {
  const [isModalOpen, setIsModalOpen] = useSafeState(false);
  const { t } = useTranslation();

  const handleCopyToClipboard = () => {
    copyToClipboard(window.location.href);
    toast.success(t('copySuccess'));
  };

  return (
    <>
      <button type="button" onClick={() => setIsModalOpen(true)}>
        <Icon name="share" iconStyle="fad" classes="w-4 h-4 text-gray-500 lg:w-5 lg:h-5" />
        <span className="sr-only">{t('buttons.shareLink')}</span>
      </button>

      <Modal
        isOpen={isModalOpen}
        size="small"
        body={
          <div className="flex flex-col gap-6 justify-center ">
            <EmailShareButton url={window.location.href}>
              <div className="flex gap-2 items-center">
                <EmailIcon size={32} round={true} />
                <p className="leading-none">{t('socialShare.email')} </p>
              </div>
            </EmailShareButton>

            <WhatsappShareButton url={window.location.href}>
              <div className="flex gap-2 items-center">
                <WhatsappIcon size={32} round={true} />
                <p className="leading-none">{t('socialShare.whatsapp')} </p>
              </div>
            </WhatsappShareButton>

            <button type="button" onClick={handleCopyToClipboard} className="flex gap-2 items-center">
              <Icon name="copy" classes="h-7" />
              <p className="leading-none">{t('socialShare.copy')} </p>
            </button>
          </div>
        }
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default SocialShare;
